<template>
  <section v-if="profile">
    <div class="container-fluid mt-2">
      
      <div class="sidebar-header">      
        <div class="user-info">
          <div class="user-pic">
            <img class="img-responsive img-rounded" :src="imageUrl" alt="User picture">
          </div>
          <span class="user-name">
            <i class="fas fa-circle online"></i> {{ profile.name }}
          </span>        
          <span class="user-role">{{ profile.team.name }}</span>
          <span class="user-role">{{ profile.email }}</span>
        </div>
      </div>      
      <team-profile :profile="profile"></team-profile>
    </div>
  </section>
</template>
<script>
import TeamProfile from "@/components/Team/Profile";
export default {
  props: ["profileId"],
  components: {
    TeamProfile
  },
  data() {
    return {
      locale: this.$i18n.locale,
      locales: this.$store.getters["lang/locales"],
      user: this.$store.getters["auth/user"],
      profile: this.user
    };
  },
  methods: {
    updatedUser: function(data) {
      this.$set(this.items, data.index, data.updatedInfo);
    },
    showEdit() {
      if (this.profile.id == this.profileId) {
        return false;
      }
      if (this.profile.superAdmin == 1) {
        return true;
      }
      if (this.profile.isAdmin == 1) {
        return true;
      }
      return false;
    },
    updateInformation() {
      this.$i18n.locale = this.locale;
    },
    showState: function() {
      if (this.profile.state === 0) {
        return this.$t("TEAM.ACTIVE");
      }
      return this.$t("TEAM.INACTIVE");
    },
    showAdmin: function() {
      if (this.profile.isAdmin === 1) {
        return this.$t("YES");
      }
      return this.$t("NO");
    },
    getProfile: function() {
      let self = this;
      this.$http
        .get(
          process.env.VUE_APP_BACKEND + "/profile/information/" + this.profileId
        )
        .then(response => {
          this.profile = response.data;
        })
        .catch(function() {
          self.$noty.error(self.$t("ERROR.COULD_NOT_FETCH_DATA"));
        });
    }
  },
  computed: {
    getSelected() {
      return this.locales[this.locale];
    },
    profileImage() {
      if (this.profile.imageExtension == null) {
        return "/img/default-avatar.png";
      } else {
        return process.env.VUE_APP_BACKEND + "/profile/image/" + this.profileId;
      }
    },
    imageUrl: function() {
      if (this.profile.imageExtension == null) {      
        return "/img/default-avatar.png";
      } else {
        return process.env.VUE_APP_BACKEND + "/profile/image/" + this.profile.id + "?date=" + Date.now();
        /*return 
          process.env.VUE_APP_BACKEND +
          "/profile/image/" +
          this.profile.id +
          "?=" +
          Date.now();*/
      }
    }
  },
  mounted() {
    this.getProfile();
  }
};
</script>
<style>
</style>
